// Packages Selectors
export const selectPackages = (state) => state.packages.packages;
export const selectPackagesLoading = (state) => state.packages.packages.loading;
export const selectPackagesError = (state) => state.packages.packages.error;
export const selectPackagesData = (state) => state.packages.packages.data;

export const selectSelectedPackage = (state) => state.packages.selectedPackage;
export const selectSelectedPackageLoading = (state) =>
  state.packages.selectedPackage.loading;
export const selectSelectedPackageData = (state) =>
  state.packages.selectedPackage.data;
export const selectSelectedPackageError = (state) =>
  state.packages.selectedPackage.error;

export const selectPackageSearchResults = (state) =>
  state.packages.searchResults;
export const selectPackageSearchLoading = (state) =>
  state.packages.searchResults.loading;
export const selectPackageSearchData = (state) =>
  state.packages.searchResults.data;
export const selectPackageSearchTotalCount = (state) =>
  state.packages.searchResults.totalCount;

export const selectPackageComparison = (state) => state.packages.comparison;
export const selectPackageComparisonLoading = (state) =>
  state.packages.comparison.loading;
export const selectPackageComparisonData = (state) =>
  state.packages.comparison.data;
